import fetch from 'cross-fetch';
import {
	LoginCrossPlatformAction,
	RemoteLoginCrossPlatformRequest,
	RegisterResponse
} from './login-cross-platform';
import { sameOriginRequestPolicy } from '../actions';


export class RemoteLoginCrossPlatformAction {
	private readonly baseUrl: string | null;

	constructor(baseUrl: string | null) {
		this.baseUrl = baseUrl;
	}
	action: LoginCrossPlatformAction = async (registerRequest: RemoteLoginCrossPlatformRequest): Promise<RegisterResponse> => {
		const base = this.baseUrl || '';
		const response: Response = await fetch(`${base}/api/login-hub/cross-platform-login`, {
			...sameOriginRequestPolicy,
			method: 'POST',
			body: JSON.stringify(registerRequest)
		});

		if (!response.ok) {
			throw new Error('unexpected');
		}

		return await response.json();
	};
}
